import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-notices-rss-feeds-form',
    templateUrl: './notices-rss-feeds-form.component.html',
    styleUrls: ['./notices-rss-feeds-form.component.scss'],
})
export class NoticesRssFeedsFormComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
